export enum PlanTypeEnum {
  TAG = "TAG",
  PLAN = "PLAN"
}
